import React, { useState } from 'react';
import { Box, HStack, View, Pressable, Text, useTheme } from 'native-base';
import { ImageBackground, StyleSheet } from 'react-native';
import Channels from '../menus/Channels';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faMessagePlus, faMagnifyingGlass, faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { getImage } from '../../utils/images';
import { useCategoriesState } from '../../../context/categories';
import SearchForumModal from '../../search/SearchForumModal';
import NotificationPopover from '../../notification/NotificationPopover';
const Overview = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const [showChannels, setShowChannels] = useState(false);
  const categoryState = useCategoriesState();
  const {
    allPostsImagePaths,
    selectedCategory
  } = categoryState;
  const carrotsImage = {
    uri: getImage('carrots')
  };
  const [showSearchModal, setShowSearchModal] = useState(false);
  const handleShowChannels = () => {
    setShowChannels(!showChannels);
  };
  const OverviewFontAwesomeIcon = _ref => {
    let {
      icon
    } = _ref;
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: icon,
      color: colors.overview.icon
    });
  };
  const categoryName = selectedCategory ? selectedCategory.name : 'All Posts';
  const categoryImage = selectedCategory ? selectedCategory.uploaded_background ?
  // If a category is selected and it has a background, use it. Otherwise fall back to default
  selectedCategory.uploaded_background.url : carrotsImage :
  // If no category and we have a all_posts_url, use it. Otherwise, use default.
  allPostsImagePaths.header ? allPostsImagePaths.header : carrotsImage;
  const boxHeight = 159;
  const Placeholder = () => {
    return /*#__PURE__*/React.createElement(Box, {
      w: '100%'
    }, /*#__PURE__*/React.createElement(HStack, {
      w: '100%',
      h: 71
    }, /*#__PURE__*/React.createElement(Text, null, " ")));
  };
  const newTopicButtonClicked = () => {
    props.startNewTopicButtonRef.current.click();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showSearchModal && /*#__PURE__*/React.createElement(SearchForumModal, {
    navigation: props.navigation,
    showSearchModal: showSearchModal,
    setShowSearchModal: setShowSearchModal
  }), /*#__PURE__*/React.createElement(Box, {
    justifyContent: 'center',
    alignItems: 'center',
    w: '100%',
    h: boxHeight,
    bg: colors.overview.bg
  }, /*#__PURE__*/React.createElement(ImageBackground, {
    source: categoryImage,
    imageStyle: {
      opacity: 0.5
    },
    style: styles.backgroundImage
  }, /*#__PURE__*/React.createElement(View, {
    w: '100%',
    display: {
      base: 'none',
      lg: 'block'
    },
    style: {
      position: 'absolute',
      bottom: 30,
      left: 30
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.overview.channel.name,
    fontSize: 'xl',
    fontWeight: 'bold',
    mr: 5
  }, categoryName)), /*#__PURE__*/React.createElement(View, {
    w: '100%',
    display: {
      base: 'block',
      lg: 'none'
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    px: 4,
    py: 6,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    opacity: 1
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: handleShowChannels
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.overview.channel.name,
    fontSize: 'xl',
    fontWeight: 'bold',
    mr: 5
  }, categoryName), /*#__PURE__*/React.createElement(OverviewFontAwesomeIcon, {
    icon: showChannels ? faChevronUp : faChevronDown
  }))), /*#__PURE__*/React.createElement(HStack, {
    w: '40%',
    justifyContent: 'space-around'
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => newTopicButtonClicked(),
    bg: colors.overview.button.bg,
    rounded: '3xl',
    p: 2
  }, /*#__PURE__*/React.createElement(OverviewFontAwesomeIcon, {
    icon: faMessagePlus
  })), /*#__PURE__*/React.createElement(Pressable, {
    bg: colors.overview.button.bg,
    rounded: '3xl',
    p: 2,
    onPress: () => setShowSearchModal(true)
  }, /*#__PURE__*/React.createElement(OverviewFontAwesomeIcon, {
    icon: faMagnifyingGlass
  })), /*#__PURE__*/React.createElement(NotificationPopover, {
    navigation: props.navigation,
    orientation: "vertical"
  }))), showChannels && /*#__PURE__*/React.createElement(Channels, {
    orientation: "horizontal",
    setPage: props.setPage,
    setHasMoreTopics: props.setHasMoreTopics
  }), !showChannels && /*#__PURE__*/React.createElement(Placeholder, null)))));
};
export default Overview;
const styles = StyleSheet.create({
  backgroundImage: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  }
});
//# sourceMappingURL=Overview.js.map